import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//dropdown GRUPOS DE AFINIDAD
const DetalleGA1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrGrupoAfin}</option>
  )
};

const ListaGA = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleGA1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrGrupoAfin" id="miListaGA" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown GRUPOS DE AFINIDAD

//dropdown NODOS
const DetalleNodo1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.descrNodo} style={props.styles.input}>{props.elemento.descrNodo}</option>
  )
};

const ListaNodo = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNodo1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrNodo" id="miListaNodo" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown NODOS

//dropdown CLASES
const DetalleNivelClase = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const ListaClase = ({styles, handleLista4, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelClase styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4} onClick={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES
//dropdown ESTADOS
const DetalleNivel1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento.estadoCli}>{props.elemento.estadoCli}</option>
  )
};

const Lista = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoCli" id="miLista6" value={argsDocum.estadoCli} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ESTADOS
//dropdown RECURSOS
const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaRecaudo = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="recaudo" id="miLista5" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown RECURSOS
//Lista de OS
const DetCli = ({elemento, opciones1, empresaArchFE}) => {
  if(opciones1==="opcion4"&&empresaArchFE!=="conectic"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        {empresaArchFE!=="codisert" &&
          <td className=''>{elemento.nombreZona}</td>
        }
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.telefonos}</td>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.estadoCliente.substr(0, 2)}</td>
        <td className=''>{elemento.cargoMensual}</td>
        <td className=''>{elemento.fechaPrimeraActivacion?elemento.fechaPrimeraActivacion.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltDX?elemento.fechaUltDX.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltPago?elemento.fechaUltPago.substr(0, 10):""}</td>
        <td className=''>{elemento.valorUltPago?elemento.valorUltPago:0}</td>
        <td className=''>{elemento.saldoPendiente}</td>
        <td className=''>{elemento.diasMora}</td>
        {empresaArchFE==="codisert" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {empresaArchFE==="codisert" &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="codisert" &&
          <td className=''>{elemento.descrTipoCliente}</td>
        }
      </tr>
    )
  }
  if(opciones1==="opcion4"&&empresaArchFE==="conectic"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        {empresaArchFE!=="codisert" &&
          <td className=''>{elemento.nombreZona}</td>
        }
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.telefonos}</td>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.sexoCliente}</td>
        <td className=''>{elemento.estadoCliente.substr(0, 2)}</td>
        <td className=''>{elemento.cargoMensual}</td>
        <td className=''>{elemento.fechaPrimeraActivacion?elemento.fechaPrimeraActivacion.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltDX?elemento.fechaUltDX.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltPago?elemento.fechaUltPago.substr(0, 10):""}</td>
        <td className=''>{elemento.valorUltPago?elemento.valorUltPago:0}</td>
        <td className=''>{elemento.saldoPendiente}</td>
        <td className=''>{elemento.diasMora}</td>
        <td className=''>{elemento.infAdic1}</td>
      </tr>
    )
  }
  if(opciones1==="opcion5"){
    let numeroDoc = elemento.numeroDoc
    let digitoVerifEmp = ""
    if(empresaArchFE==="codisert"){
      let posic = numeroDoc.indexOf("-")
      if(posic!==-1){
        digitoVerifEmp = numeroDoc.substr(posic + 1)
        numeroDoc = numeroDoc.substr(0, posic)
      }
    }
    let razonSocial = ""
    if(elemento.codigoTipoDoc==="NIT"){
      razonSocial = elemento.nombreCliente + " " + elemento.apellidoCliente
    }
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        {empresaArchFE!=="codisert" &&
          <td className=''>{elemento.nombreZona}</td>
        }
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        {empresaArchFE==="codisert" &&
          <td className=''>{razonSocial}</td>
        }
        <td className=''>{elemento.telefonos}</td>
        {/* <td className=''>{elemento.direccionCli.substr(0, 40)}</td>
        <td className=''>{elemento.nombreCliente.substr(0, 15)}</td>
        <td className=''>{elemento.apellidoCliente.substr(0, 15)}</td>
        <td className=''>{elemento.telefonos.substr(0, 15)}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{numeroDoc}</td>
        {empresaArchFE==="codisert" &&
          <td className=''>{digitoVerifEmp}</td>
        }
        <td className=''>{elemento.eMail}</td>
        <td className=''>{elemento.observaciones}</td>
        <td className=''>{elemento.estadoCliente.substr(0, 2)}</td>
        <td className=''>{elemento.codigoMarquilla}</td>
        <td className=''>{elemento.descrGrupoAfin}</td>
        <td className=''>{elemento.cargoMensual}</td>
        <td className=''>{elemento.fechaCreacionSistema?elemento.fechaCreacionSistema.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaPrimeraActivacion?elemento.fechaPrimeraActivacion.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltDX?elemento.fechaUltDX.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltPago?elemento.fechaUltPago.substr(0, 10):""}</td>
        <td className=''>{elemento.valorUltPago?elemento.valorUltPago:0}</td>
        <td className=''>{elemento.saldoPendiente}</td>
        <td className=''>{elemento.diasMora}</td>
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.fechaCumple?elemento.fechaCumple.substr(0, 10):""}</td>
        }
      </tr>
    )
  }
  if(opciones1==="opcion6"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        {empresaArchFE!=="codisert" &&
          <td className=''>{elemento.nombreZona}</td>
        }
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.telefonos}</td>
        {/* <td className=''>{elemento.direccionCli.substr(0, 40)}</td>
        <td className=''>{elemento.nombreCliente.substr(0, 15)}</td>
        <td className=''>{elemento.apellidoCliente.substr(0, 15)}</td>
        <td className=''>{elemento.telefonos.substr(0, 15)}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.descrEstrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        {empresaArchFE==="conectic" &&
          <td className=''>{elemento.eMail}</td>
        }
        <td className=''>{elemento.observaciones}</td>
        <td className=''>{elemento.estadoCliente.substr(0, 2)}</td>
        <td className=''>{elemento.cargoMensual}</td>
        <td className=''>{elemento.fechaCreacionSistema?elemento.fechaCreacionSistema.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaPrimeraActivacion?elemento.fechaPrimeraActivacion.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltDX?elemento.fechaUltDX.substr(0, 10):""}</td>
        <td className=''>{elemento.fechaUltPago?elemento.fechaUltPago.substr(0, 10):""}</td>
        <td className=''>{elemento.valorUltPago?elemento.valorUltPago:0}</td>
        <td className=''>{elemento.saldoPendiente}</td>
        <td className=''>{elemento.diasMora}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.codigoTarifa}</td>
        <td className=''>{elemento.descrTarifa}</td>
        <td className=''>{elemento.codigoServicio}</td>
        <td className=''>{elemento.nombreResumido}</td>
        <td className=''>{elemento.codigoPaquete}</td>
        <td className=''>{elemento.descrPaquete}</td>
        <td className=''>{elemento.codigoSegmento}</td>
        <td className=''>{elemento.descrSegmento}</td>
        <td className=''>{elemento.codigoTipoTec}</td>
        <td className=''>{elemento.descrTipoTec}</td>
        <td className=''>{elemento.velEfecDownstream}</td>
        <td className=''>{elemento.velEfecUpstream}</td>
        <td className=''>{elemento.mac?elemento.mac:""}</td>
        <td className=''>{elemento.descrClaseEqu?elemento.descrClaseEqu:""}</td>
      </tr>
    )
  }
  if(opciones1==="opcion7"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrDpto}</td>
        <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.estadoCliente}</td>
        <td className=''>{elemento.cicloFact}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.totalClientes.toString())}</td>
      </tr>
    )
  }
  if(opciones1==="opcion8"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrDpto}</td>
        <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.estadoCliente}</td>
        <td className=''>{elemento.cicloFact}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.totalClientes.toString())}</td>
      </tr>
    )
  }
  if(opciones1==="opcion9"){
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.telefono1}</td>
        <td className=''>{elemento.telefono2}</td>
        <td className=''>{elemento.telefono3}</td>
        <td className=''>{elemento.estadoCliente}</td>
        <td className='right aligned'>{general.formatNum(elemento.saldoPendiente.toString())}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.cicloFact}</td>
        {/* <td className=''>{elemento.numBoleta}</td>
        <td className=''>{elemento.estado}</td>
        <td className=''>{elemento.agno}</td>
        <td className=''>{elemento.mes}</td> */}
        <td className=''>{elemento.numSorteos}</td>
      </tr>
    )
  }
};

const ListaCli = ({list, opciones1, empresaArchFE}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetCli elemento={elemento} key={i} opciones1={opciones1} empresaArchFE={empresaArchFE}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let argsBuscarMC = {tipoqry: `[{$match: {tipo: 'X'}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
// let argsBuscarCLR = {tipoqry: `[{$match: {contrato: 'XXYYZZ'}},{$lookup: {from: 'movclientes', localField: 'contrato', foreignField: 'contrato', as: 'movimientos'}}]`}

class RtesCli2 extends React.Component {
  state={argsDocum: {_id: "", diasMoraIni: 0, diasMoraFin: 0, numeroDocum: "", descrRecurso: "Todos...",
        estadoCli: "ACTIVO", descrClaseServ: "Todas...", checkDiasMoraIni: false, checkDiasMoraFin: false,
        cicloFact: "Todos...", descrGrupoAfin: "Todos...", descrNodo: "Todos...",
        descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...", nombreBarrio: "Todos..."},
        opciones: "opcion1", opciones1: "opcion4", argsSelDpto: this.props.argsSelDpto, listRtes: [],
        totCli: 0, confirmaAct: false, open: false, errors: [], renderizar: true,
        verEnPantalla: false}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsDocum = this.state.argsDocum
    let miLista5 = document.getElementById("miLista5");
    let listRtes = []
    this.setState({listRtes, totCli: 0})
    this.setState({verEnPantalla: false})

    if(ev.target.name==="opciones"||ev.target.name==="opciones1"){
      if(ev.target.checked===true){
        if(ev.target.name==="opciones"){
          this.setState({opciones: ev.target.value})
        }else{
          this.setState({opciones1: ev.target.value})
        }
      }
    }else{  
      if(ev.target.name === "recaudo"){
        if(miLista5.options[miLista5.selectedIndex].text==="Todos..."){
          argsDocum['numeroDocum'] = ""
          argsDocum['descrRecurso'] = miLista5.options[miLista5.selectedIndex].text
        }else{
          argsDocum['numeroDocum'] = miLista5.options[miLista5.selectedIndex].attributes[0].value
          argsDocum['descrRecurso'] = miLista5.options[miLista5.selectedIndex].attributes[1].value
        }
      }else{
        if(ev.target.name === "checkDiasMoraIni"||ev.target.name === "checkDiasMoraFin"){
          argsDocum[ev.target.name] = ev.target.checked
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
      }
    }

    this.setState({argsDocum});
    // console.log(argsDocum)
  }

  handleSubmit = async (ev, argsDocum, opciones, opciones1)=>{
    // console.log(ev.target.name)
    let targetName = ev.target.name
    // console.log(argsDocum)
    document.body.style.cursor = 'wait'

    if(targetName==="pantalla"||targetName==="pdf"){
      this.setState({verEnPantalla: true})
    }
    if((targetName==="pantalla"&&this.state.listRtes.length===0)||this.state.listRtes.length===0){
      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let argsUpd
      let errors = []
      if(!this.props.allClientes.allClientes){
        // console.log("no ha cargado allClientes")
        errors.push({path: "Clientes", message: "Proceso de cargue de la información, por favor espere un momento..."});
      }
      // console.log(this.state.argsDocum)
      this.setState({errors})
      if(errors.length===0){
        this.setState({renderizar: false})
        //Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
        // let clientesFra = []
        let argsBuscarCL={}, argsBuscarCLR=""
        argsBuscarCL.contrato=null
        argsBuscarCL.estadoCliente=null
        argsBuscarCL.cicloFact=null
        argsBuscarCL.descrGrupoAfin=null
        argsBuscarCL.descrRecursoR=null
        argsBuscarCL.descrClaseServ=null
        argsBuscarCL.descrDpto=null
        argsBuscarCL.nombreCiudad=null
        argsBuscarCL.nombreZona=null
        argsBuscarCL.nombreBarrio=null
        argsBuscarCL.descrNodo=null

        argsBuscarCL.numDocum = 99999
        if(this.state.argsDocum.cicloFact!=="Todos..."){
          argsBuscarCL.cicloFact = this.state.argsDocum.cicloFact

          argsBuscarCLR = `'cicloFact': '${this.state.argsDocum.cicloFact}'`
        }

        if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&this.state.argsDocum.descrGrupoAfin!=="Todos..."){
          argsBuscarCL.descrGrupoAfin = this.state.argsDocum.descrGrupoAfin
        }
        if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&this.state.argsDocum.descrNodo!=="Todos..."){
          argsBuscarCL.descrNodo = this.state.argsDocum.descrNodo
        }

        let clientesLis = []
        if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!==""){
          if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&this.state.argsDocum.descrRecurso!=="Todos..."){
            argsBuscarCL.estadoCliente=this.state.argsDocum.estadoCli
            argsBuscarCL.descrRecursoR=this.state.argsDocum.descrRecurso

            // argsBuscarCLR = `'estadoCliente': '${this.state.argsDocum.estadoCli}', 
            //   'dirmayor.ciudades.zonas.barrios.descrRecursoR': '${this.state.argsDocum.descrRecurso}'`
          }else{
            argsBuscarCL.estadoCliente=this.state.argsDocum.estadoCli

            if(argsBuscarCLR){argsBuscarCLR += `, `}
            argsBuscarCLR += `'estadoCliente': '${this.state.argsDocum.estadoCli}'`
          }
        }else{
          if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&this.state.argsDocum.descrRecurso!=="Todos..."){
            argsBuscarCL.descrRecursoR=this.state.argsDocum.descrRecurso
          
            // argsBuscarCLR = `'dirmayor.ciudades.zonas.barrios.descrRecursoR': '${this.state.argsDocum.descrRecurso}'`
          }
        }

        // console.log(this.state.argsSelDpto.descrClaseServ)
        if(this.state.argsSelDpto.descrClaseServ!==undefined&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
          argsBuscarCL.descrClaseServ=this.state.argsSelDpto.descrClaseServ

          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'tarifa.servicios.subclaseserv.claseserv.descrClaseServ': '${this.state.argsSelDpto.descrClaseServ}'`
        }

        if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){
          // clientesLis = clientesLis
        }else{
          if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
            argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto

            if(argsBuscarCLR){argsBuscarCLR += `, `}
            argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}'`
          }else{
            if(opciones1==="opcion7"||this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
              argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
              argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad

              if(argsBuscarCLR){argsBuscarCLR += `, `}
              argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                  'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
            }else{
              if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
                argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
                argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona

                if(argsBuscarCLR){argsBuscarCLR += `, `}
                argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              }else{
                argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
                argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
                argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona
                argsBuscarCL.nombreBarrio=this.state.argsSelDpto.nombreBarrio

                if(argsBuscarCLR){argsBuscarCLR += `, `}
                argsBuscarCLR += `'descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'nombreZona': '${this.state.argsSelDpto.nombreZona}', 
                    'nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
              }
            }
          }
        }

        // console.log(this.state.argsSelDpto)

        let campos = `{_id: 1, contrato: 1, saldoPendiente: 1, diasMora: 1, direccion: 1, telefono1: 1, telefono2: 1, telefono3: 1,
          tarifa: 1, dirmayor: 1, descrNodo: 1, equipos: 1, nombreCliente: 1, apellidoCliente: 1, descrEstrato: 1, tipodoc: 1, grupoaf: 1,
          codigoPaquete: 1, descrPaquete: 1, codigoSegmento: 1, descrSegmento: 1, codigoMarquilla: 1,
          numeroDoc: 1, eMail: 1, observaciones: 1, estadoCliente: 1, cargoMensual: 1, fechaCreacionSistema: 1,
          fechaPrimeraActivacion: 1, fechaUltDX: 1, fechaUltPago: 1, valorUltPago: 1, infAdic1: 1, sexoCliente: 1, fechaCumple: 1, cicloFact: 1, tipocl: 1}`

        argsBuscarCL.campos = campos

        clientesLis = []
        argsBuscarCLR = `${argsBuscarCLR}`
        if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9"&&this.props.allClientes.allClientes){
          // console.log(argsBuscarCL)
          // console.time(1)
          let {data} = await this.props.allClientes.refetch(argsBuscarCL)
          clientesLis = await data.allClientes
          // console.timeEnd(1)
          console.log(clientesLis)
          await this.props.allClientes.refetch({numDocum: 1})
        }
        if(opciones1==="opcion7"&&this.props.allClientesRtes.allClientesRtes){
          argsBuscarCLR = '{' + argsBuscarCLR + '}'
          argsBuscarCLR = {tipoqry: `[
            {$project: {contrato: 1, estadoCliente: 1,
              descrDpto: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.descrDpto", else: "" } },
              nombreCiudad: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.ciudades.nombreCiudad", else: "" } },
              tarifa: {$cond: { if: { $ifNull: [ "$tarifa", false ] }, then: "$tarifa", else: {servicios: [{subclaseserv: {claseserv: {descrClaseServ: ""}}}]} } },
              cicloFact: {$cond: { if: { $ifNull: [ "$cicloFact", false ] }, then: "$cicloFact", else: "" } },
            }},
            {"$unwind":"$tarifa.servicios"},
            {$match: ${argsBuscarCLR}},
            {$group: {_id: {contrato: '$contrato', descrDpto: '$descrDpto', nombreCiudad: '$nombreCiudad', estadoCliente: '$estadoCliente',
                cicloFact: '$cicloFact', descrClaseServ: '$tarifa.servicios.subclaseserv.claseserv.descrClaseServ'}}},
            {$group: {_id: {descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', estadoCliente: '$_id.estadoCliente',
                cicloFact: '$_id.cicloFact', descrClaseServ: '$_id.descrClaseServ'},
                cargoMensual: {$sum: 1}}},
            {$project: {_id: {$concat: ['$_id.descrDpto', '$_id.nombreCiudad', '$_id.estadoCliente',
                '$_id.cicloFact', '$_id.descrClaseServ']},
                nombreCliente: '$_id.descrDpto', apellidoCliente: '$_id.nombreCiudad', estadoCliente: '$_id.estadoCliente',
                cicloFact: '$_id.cicloFact', descrEstrato: '$_id.descrClaseServ', cargoMensual: 1
            }},
            {$sort: {nombreCliente: 1, apellidoCliente: 1, estadoCliente: 1, cicloFact: 1, descrEstrato: 1}},              
          ]`}
          // console.log(argsBuscarCLR)
          // console.time(1)
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarCLR)
          clientesLis = await data.allClientesRtes
          // console.timeEnd(1)
        }
        if(opciones1==="opcion8"&&this.props.allClientesRtes.allClientesRtes){
          argsBuscarCLR = '{' + argsBuscarCLR + '}'
          // console.log(argsBuscarCLR)
          argsBuscarCLR = {tipoqry: `[
            {$project: {contrato: 1, estadoCliente: 1,
              descrDpto: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.descrDpto", else: "" } },
              nombreCiudad: {$cond: { if: { $ifNull: [ "$dirmayor", false ] }, then: "$dirmayor.ciudades.nombreCiudad", else: "" } },
              nombreZona: {$cond: { if: { $ifNull: [ "$dirmayor.ciudades.zonas", false ] }, then: "$dirmayor.ciudades.zonas.nombreZona", else: "" } },
              nombreBarrio: {$cond: { if: { $ifNull: [ "$dirmayor.ciudades.zonas", false ] }, then: "$dirmayor.ciudades.zonas.barrios.nombreBarrio", else: "" } },
              tarifa: {$cond: { if: { $ifNull: [ "$tarifa", false ] }, then: "$tarifa", else: {servicios: [{subclaseserv: {claseserv: {descrClaseServ: ""}}}]} } },
              cicloFact: {$cond: { if: { $ifNull: [ "$cicloFact", false ] }, then: "$cicloFact", else: "" } },
            }},
            {$unwind:"$tarifa.servicios"},
            {$match: ${argsBuscarCLR}},
            {$group: {_id: {contrato: '$contrato', descrDpto: '$descrDpto', nombreCiudad: '$nombreCiudad', nombreBarrio: '$nombreBarrio', estadoCliente: '$estadoCliente',
                cicloFact: '$cicloFact', descrClaseServ: '$tarifa.servicios.subclaseserv.claseserv.descrClaseServ'}}},
            {$group: {_id: {descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', nombreBarrio: '$_id.nombreBarrio', estadoCliente: '$_id.estadoCliente',
                cicloFact: '$_id.cicloFact', descrClaseServ: '$_id.descrClaseServ'},
                cargoMensual: {$sum: 1}}},
            {$project: {_id: {$concat: ['$_id.descrDpto', '$_id.nombreCiudad', '$_id.nombreBarrio', '$_id.estadoCliente',
                '$_id.cicloFact', '$_id.descrClaseServ']},
                nombreCliente: '$_id.descrDpto', apellidoCliente: '$_id.nombreCiudad', referencia1: '$_id.nombreBarrio', estadoCliente: '$_id.estadoCliente',
                cicloFact: '$_id.cicloFact', descrEstrato: '$_id.descrClaseServ', cargoMensual: 1
            }},
            {$sort: {nombreCliente: 1, apellidoCliente: 1, referencia1: 1, estadoCliente: 1, cicloFact: 1, descrEstrato: 1}},
          ]`}
          // console.log(argsBuscarCLR)
          // console.time(1)
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarCLR)
          clientesLis = await data.allClientesRtes
          // console.timeEnd(1)
        }
        // if(opciones1==="opcion9"&&this.props.allBoletaRtes.allBoletaRtes){
        //   let argsBuscarCLR = {tipoqry: `[
        //     {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
        //     {$project: {numBoleta: 1, agno: 1, mes: 1, contrato: 1, estado: 1,
        //         'cliente': {
        //              $cond: { if: { $eq: [ { $size: '$cliente' }, 0 ] },
        //                 then: [{nombreCliente: "", apellidoCliente: "", estadoCliente: "", saldoPendiente: 0, cicloFact: ""}],
        //                 else: "$cliente"} 
        //             }
        //     }},
        //     {$unwind: "$cliente"},
        //     {$project: {numBoleta: 1, agno: 1, mes: 1, contrato: 1, estado: 1,
        //         nombreCliente: "$cliente.nombreCliente", apellidoCliente: "$cliente.apellidoCliente",
        //         estadoCliente: "$cliente.estadoCliente", saldoPendiente: "$cliente.saldoPendiente", cicloFact: "$cliente.cicloFact"}},
        //   ]`}
        //   // console.log(argsBuscarCLR)
        //   // console.time(1)
        //   let {data} = await this.props.allBoletaRtes.refetch(argsBuscarCLR)
        //   clientesLis = await data.allBoletaRtes
        //   // console.timeEnd(1)
        // }
        if(opciones1==="opcion9"&&this.props.allClientesRtes.allClientesRtes){
          // argsBuscarCLR = {tipoqry: `[
          //   {$match: {numSorteos: {$nin: ["", null]}}},
          //   {$project: {contrato: 1, nombreCliente: 1, apellidoCliente: 1, estadoCliente: 1,
          //     saldoPendiente: 1, cicloFact: 1, numSorteos: 1
          //   }},
          //   {$sort: {numSorteos: 1}},
          // ]`}
          argsBuscarCLR = {tipoqry: `[
            {$match: {tag: {$nin: ["", null]}}},
            {$project: {contrato: 1, nombreCliente: 1, apellidoCliente: 1, numeroDoc: 1, telefono1: 1, telefono2: 1, telefono3: 1, estadoCliente: 1,
              saldoPendiente: 1, cicloFact: 1, numSorteos: '$tag', dirmayor: 1
            }},
            {$sort: {numSorteos: 1}},
          ]`}

          console.log(argsBuscarCLR)
          // console.time(1)
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarCLR)
          clientesLis = await data.allClientesRtes
          // console.timeEnd(1)
        }
        console.log(clientesLis)
        // console.log(opciones1)
        // console.log(this.state.argsDocum)
        let listRtes = []
        let totCli = 0
        // console.time(3)
        clientesLis.forEach(async (elemento1, i) => {
          // for(let i=0; i<clientesLis.length; i++){
          //   let elemento1 = clientesLis[i]

          let diasMora = elemento1.diasMora

          let filtroPorMOraOK = true
          if(argsDocum.checkDiasMoraIni&&diasMora<this.state.argsDocum.diasMoraIni){
            filtroPorMOraOK = false
          }
          if(filtroPorMOraOK&&argsDocum.checkDiasMoraFin&&diasMora>this.state.argsDocum.diasMoraFin){
            filtroPorMOraOK = false
          }
        
          if(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9"&&filtroPorMOraOK){
            let direccionCli = ""
            if(elemento1.direccion&&elemento1.direccion.descrTipoVia1){
              direccionCli = elemento1.direccion.descrTipoVia1?elemento1.direccion.descrTipoVia1:""
              direccionCli += elemento1.direccion.numeroTipoVia1?" " + elemento1.direccion.numeroTipoVia1:""
              direccionCli += elemento1.direccion.descrTipoVia2?" " + elemento1.direccion.descrTipoVia2:""
              direccionCli += elemento1.direccion.numeroTipoVia2?" " + elemento1.direccion.numeroTipoVia2:""
              direccionCli += elemento1.direccion.numeroTipoVia2F?" " + elemento1.direccion.numeroTipoVia2F:""
              direccionCli += elemento1.direccion.descrTipoUnd1?" " + elemento1.direccion.descrTipoUnd1:""
              direccionCli += elemento1.direccion.numeroTipoUnd1?" " + elemento1.direccion.numeroTipoUnd1:""
              direccionCli += elemento1.direccion.descrTipoUnd2?" " + elemento1.direccion.descrTipoUnd2:""
              direccionCli += elemento1.direccion.numeroTipoUnd2?" " + elemento1.direccion.numeroTipoUnd2:""
            }
            let telefonos = ""
            if(elemento1.telefono1){telefonos = elemento1.telefono1}
            if(elemento1.telefono2){telefonos?telefonos += "-" + elemento1.telefono2:telefonos = elemento1.telefono2}
            if(elemento1.telefono3){telefonos?telefonos += "-" + elemento1.telefono3:telefonos = elemento1.telefono3}

            argsUpd = {}
            if(opciones1==="opcion6"){
              if(elemento1.tarifa&&elemento1.tarifa.codigoTarifa){
                elemento1.tarifa.servicios.forEach((elemento2, i) => {
                // for(let i=0; i<elemento1.tarifa.servicios.length; i++){
                //   let elemento2 = elemento1.tarifa.servicios[i]

                  argsUpd = {
                    "descrRecursoR": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.descrRecursoR:"",
                    "codigoCiudad": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.codigoCiudad:"",
                    "nombreZona": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.nombreZona:"",
                    "nombreBarrio": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                    "direccionCli": direccionCli,
                    "descrNodo": elemento1.descrNodo,
                    "nombreCliente": elemento1.nombreCliente,
                    "apellidoCliente": elemento1.apellidoCliente,
                    "telefonos": telefonos,
                    "contrato": elemento1.contrato,
                    "descrEstrato": elemento1.descrEstrato,
                    "codigoTipoDoc": elemento1.tipodoc.codigoTipoDoc,
                    "numeroDoc": elemento1.numeroDoc,
                    "eMail": elemento1.eMail,
                    "observaciones": elemento1.observaciones,
                    "estadoCliente": elemento1.estadoCliente,
                    "cargoMensual": elemento1.cargoMensual,
                    "fechaCreacionSistema": elemento1.fechaCreacionSistema,
                    "fechaPrimeraActivacion": elemento1.fechaPrimeraActivacion,
                    "fechaUltDX": elemento1.fechaUltDX,
                    "fechaUltPago": elemento1.fechaUltPago,
                    "valorUltPago": elemento1.valorUltPago,
                    "saldoPendiente": elemento1.saldoPendiente,
                    "diasMora": diasMora,
                    "descrClaseServ": elemento2.subclaseserv.claseserv.descrClaseServ,
                    "codigoTarifa": elemento1.tarifa.codigoTarifa,
                    "descrTarifa": elemento1.tarifa.descrTarifa,
                    "codigoServicio": elemento2.codigoServicio,
                    "nombreResumido": elemento2.nombreResumido,
                    "codigoPaquete": elemento1.codigoPaquete?elemento1.codigoPaquete:"",
                    "descrPaquete": elemento1.descrPaquete?elemento1.descrPaquete:"",
                    "codigoSegmento": elemento1.codigoSegmento?elemento1.codigoSegmento:"",
                    "descrSegmento": elemento1.descrSegmento?elemento1.descrSegmento:"",
                    "codigoTipoTec": elemento2.codigoTipoTec?elemento2.codigoTipoTec:"",
                    "descrTipoTec": elemento2.descrTipoTec?elemento2.descrTipoTec:"",
                    "velEfecDownstream": elemento2.velEfecDownstream?elemento2.velEfecDownstream:"",
                    "velEfecUpstream": elemento2.velEfecUpstream?elemento2.velEfecUpstream:"",
                  }
                  if(elemento1.equipos&&elemento1.equipos.length>0){
                    elemento1.equipos.forEach((elemento3, iiiii) => {
                    // for(let iiiii=0; iiiii<elemento1.equipos.length; iiiii++){
                    //   let elemento3 = elemento1.equipos[iiiii]
                      if(elemento3.mac){
                        argsUpd = {...argsUpd, mac: elemento3.mac, descrClaseEqu: elemento3.claseequ.descrClaseEqu}
                        listRtes.push(argsUpd)
                      }
                    // }
                    })
                  }else{
                    // console.log(elemento1.contrato)
                    listRtes.push(argsUpd)
                  }
                // }
                })
                totCli += 1
              }
            }else{
              argsUpd = {
                "descrRecursoR": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.descrRecursoR:"",
                "codigoCiudad": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.codigoCiudad:"",
                "nombreZona": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.nombreZona:"",
                "nombreBarrio": elemento1.dirmayor&&elemento1.dirmayor.codigoDpto?elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                "direccionCli": direccionCli,
                "descrNodo": elemento1.descrNodo,
                "nombreCliente": elemento1.nombreCliente,
                "apellidoCliente": elemento1.apellidoCliente,
                "telefonos": telefonos,
                "contrato": elemento1.contrato,
                "codigoTipoDoc": elemento1.tipodoc.codigoTipoDoc,
                "numeroDoc": elemento1.numeroDoc,
                "eMail": elemento1.eMail,
                "observaciones": elemento1.observaciones,
                "estadoCliente": elemento1.estadoCliente,
                "codigoMarquilla": elemento1.codigoMarquilla,
                "cargoMensual": elemento1.cargoMensual,
                "fechaCreacionSistema": elemento1.fechaCreacionSistema,
                "fechaPrimeraActivacion": elemento1.fechaPrimeraActivacion,
                "fechaUltDX": elemento1.fechaUltDX,
                "fechaUltPago": elemento1.fechaUltPago,
                "valorUltPago": elemento1.valorUltPago,
                "saldoPendiente": elemento1.saldoPendiente,
                "diasMora": diasMora,
                "infAdic1": elemento1.infAdic1?elemento1.infAdic1:"",
                "sexoCliente": elemento1.sexoCliente?elemento1.sexoCliente:"",
                "descrGrupoAfin": elemento1.grupoaf.descrGrupoAfin,
                "fechaCumple": elemento1.fechaCumple,
                "cicloFact": elemento1.cicloFact,
                "descrTipoCliente": elemento1.tipocl.descrTipoCliente,
              }
              listRtes.push(argsUpd)
              totCli += 1
            }
          }else{
            if(opciones1==="opcion7"){
              argsUpd = {
                "descrDpto": elemento1.nombreCliente?elemento1.nombreCliente:"",
                "nombreCiudad": elemento1.apellidoCliente?elemento1.apellidoCliente:"",
                "estadoCliente": elemento1.estadoCliente,
                "descrClaseServ": elemento1.descrEstrato,
                "cicloFact": elemento1.cicloFact,
                "totalClientes": elemento1.cargoMensual,
              }
              listRtes.push(argsUpd)
              // totCli += 1
            }
            if(opciones1==="opcion8"){
              argsUpd = {
                "descrDpto": elemento1.nombreCliente?elemento1.nombreCliente:"",
                "nombreCiudad": elemento1.apellidoCliente?elemento1.apellidoCliente:"",
                "nombreBarrio": elemento1.referencia1?elemento1.referencia1:"",
                "estadoCliente": elemento1.estadoCliente,
                "descrClaseServ": elemento1.descrEstrato,
                "cicloFact": elemento1.cicloFact,
                "totalClientes": elemento1.cargoMensual,
              }
              listRtes.push(argsUpd)
              // totCli += 1
            }
            if(opciones1==="opcion9"){
              argsUpd = {
                // "numBoleta": elemento1.numBoleta,
                "contrato": elemento1.contrato,
                // "agno": elemento1.agno,
                // "mes": elemento1.mes,
                // "estado": elemento1.estado,
                "nombreCliente": elemento1.nombreCliente,
                "apellidoCliente": elemento1.apellidoCliente,
                "numeroDoc": elemento1.numeroDoc,
                "telefono1": elemento1.telefono1,
                "telefono2": elemento1.telefono2,
                "telefono3": elemento1.telefono3,
                "estadoCliente": elemento1.estadoCliente,
                "nombreBarrio": elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio,
                "cicloFact": elemento1.cicloFact,
                "saldoPendiente": elemento1.saldoPendiente,
                "numSorteos": parseInt(elemento1.numSorteos, 10)
              }
              listRtes.push(argsUpd)
              // totCli += 1
            }
          }
          // }
        })
        // console.timeEnd(3)

        console.log(listRtes)
        // console.time(4)
        if(opciones==="opcion1"){
          listRtes = _.orderBy(listRtes, ['descrRecursoR', 'codigoCiudad', 'nombreBarrio', 'direccionCli'], ['asc', 'asc', 'asc', 'asc'])
        }
        if(opciones==="opcion2"){
          listRtes = _.orderBy(listRtes, ['nombreCliente', 'apellidoCliente'], ['asc', 'asc'])
        }
        if(opciones==="opcion3"){
          listRtes = _.orderBy(listRtes, ['contrato'], ['asc'])
        }
        this.setState({renderizar: true})
        this.setState({listRtes})
        this.setState({totCli})
        // console.timeEnd(4)
        clientesLis = []
        listRtes = []
      }
    }
    if(targetName==="pdf"){
      var doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      if(opciones1==="opcion7"||opciones1==="opcion8"||opciones1==="opcion9"){
        doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      }

      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 =  this.props.empresa.empresaRazonSocial
      let texto2 = "LISTADO DE CLIENTES"
      if(opciones1==="opcion9"){
        // texto2 = "LISTADO DE BOLETAS"
        texto2 = "LISTADO DE NUMEROS PARA SORTEO"
      }
      // const fechaHoy = new Date()
      // let agnoHoy = fechaHoy.getFullYear()
      // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
      // mesHoy = agnoHoy + "-" + mesHoy
      // let mesMsg = ""
      // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
      let tit1Texto3 = argsDocum.diasMoraIni
      let tit1Texto4 = argsDocum.diasMoraFin
      let texto3 = `Con mora mayor o igual a ${tit1Texto3} días y menor o igual a ${tit1Texto4} días`
      if(opciones1==="opcion7"||opciones1==="opcion8"){
        texto2 = "TOTALES"
        texto3 = ""
      }
      if(opciones1==="opcion9"){
        // texto2 = "LISTADO DE BOLETAS"
        texto2 = "LISTADO DE NUMEROS PARA SORTEO"
        texto3 = ""
      }

      doc.text(texto1, 108, 20, 'center')
      doc.setFontSize(12);
      doc.text(texto2, 108, 30, 'center')
      doc.setFontSize(10);
      doc.text(texto3, 108, 40, 'center')
  
      var source = document.getElementById("tabla");
      doc.autoTable({startY: 45,
                      tableLineColor: "blue",
                      tableLineWidth: 0.1,
                      styles: {
                        // font: 'Calibri',
                        fontSize: 8,
                        lineColor: "black",
                        lineWidth: 0.1
                      },
                      headStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 8,
                        fontWeight: "normal"
                      },
                      bodyStyles: {
                        fillColor: "#E9E4F0",
                        textColor: "black"
                      },
                      alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      html: source,
                      margin: opciones1!=="opcion7"&&opciones1!=="opcion8"?{top: 10, left: 2, right: 2}:{top: 20, left: 30, right: 30},})
      // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
      // doc.text("TOTAL", 50, finalY + 15);
      // doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana

      let nameDoc = `clientes.pdf`
      doc.autoPrint({variant: 'non-conform'});
      doc.save(nameDoc)
    }
    // if(targetName==="excel"&&this.props.empresa.empresaArchFE!=="codisert"){
    //   let xlsString = []
    //   let listRtes = this.state.listRtes
    //   // console.log(listRtes)
    //   if(this.state.opciones1==="opcion4"){
    //     let xlsString1 = []
    //     if(this.props.empresa.empresaArchFE==="conectic"){
    //       xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nodo', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Género', 'Est', '$ mes', 'F prim Act', 'F Ult DX', 'F Ult P', '$ Ult P', 'Saldo', 'Mora', 'Inf Adic']
    //     }else{
    //       xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nodo', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Est', '$ mes', 'F prim Act', 'F Ult DX', 'F Ult P', '$ Ult P', 'Saldo', 'Mora']
    //     }
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", valorUltPago = 0
    //       if(listRtes[i].fechaPrimeraActivacion){
    //         fechaPrimeraActivacion = new Date(listRtes[i].fechaPrimeraActivacion)
    //         fechaPrimeraActivacion = (fechaPrimeraActivacion.getUTCFullYear()) + '-' + ((fechaPrimeraActivacion.getUTCMonth()+1)<10?'0'+(fechaPrimeraActivacion.getUTCMonth()+1):(fechaPrimeraActivacion.getUTCMonth()+1)) + '-' + (fechaPrimeraActivacion.getUTCDate()<10?'0'+fechaPrimeraActivacion.getUTCDate():fechaPrimeraActivacion.getUTCDate())
    //         fechaPrimeraActivacion = new Date(fechaPrimeraActivacion+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaUltDX){
    //         fechaUltDX = new Date(listRtes[i].fechaUltDX)
    //         fechaUltDX = (fechaUltDX.getUTCFullYear()) + '-' + ((fechaUltDX.getUTCMonth()+1)<10?'0'+(fechaUltDX.getUTCMonth()+1):(fechaUltDX.getUTCMonth()+1)) + '-' + (fechaUltDX.getUTCDate()<10?'0'+fechaUltDX.getUTCDate():fechaUltDX.getUTCDate())
    //         fechaUltDX = new Date(fechaUltDX+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaUltPago){
    //         fechaUltPago = new Date(listRtes[i].fechaUltPago)
    //         fechaUltPago = (fechaUltPago.getUTCFullYear()) + '-' + ((fechaUltPago.getUTCMonth()+1)<10?'0'+(fechaUltPago.getUTCMonth()+1):(fechaUltPago.getUTCMonth()+1)) + '-' + (fechaUltPago.getUTCDate()<10?'0'+fechaUltPago.getUTCDate():fechaUltPago.getUTCDate())
    //         fechaUltPago = new Date(fechaUltPago+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].valorUltPago){
    //         valorUltPago = listRtes[i].valorUltPago
    //       }
    //       if(this.props.empresa.empresaArchFE==="conectic"){
    //         xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad,
    //           listRtes[i].nombreBarrio, listRtes[i].direccionCli, listRtes[i].descrNodo,
    //           listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
    //           listRtes[i].contrato, listRtes[i].sexoCliente, listRtes[i].estadoCliente,listRtes[i].cargoMensual,
    //           fechaPrimeraActivacion, fechaUltDX, fechaUltPago, valorUltPago,
    //           listRtes[i].saldoPendiente, listRtes[i].diasMora, listRtes[i].infAdic1]
    //       }else{
    //         xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad,
    //           listRtes[i].nombreBarrio, listRtes[i].direccionCli, listRtes[i].descrNodo,
    //           listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
    //           listRtes[i].contrato, listRtes[i].estadoCliente,listRtes[i].cargoMensual,
    //           fechaPrimeraActivacion, fechaUltDX, fechaUltPago, valorUltPago,
    //           listRtes[i].saldoPendiente, listRtes[i].diasMora]
    //       }

    //       // console.log(xlsString1)
    //       xlsString.push(xlsString1)
    //     }
    //     // console.log(xlsString)
    //   }
    //   if(opciones1==="opcion5"){
    //     let xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Doc', '# Doc', 'Correo', 'Observaciones', 'Est', 'Marquilla', 'Grupo Afinidad', '$ mes', 'F creac', 'F prim Act', 'F Ult DX', 'F Ult P', '$ Ult P', 'Saldo', 'Mora']
    //     if(this.props.empresa.empresaArchFE==="conectic"){
    //       xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Doc', '# Doc', 'Correo', 'Observaciones', 'Est', 'Marquilla', 'Grupo Afinidad', '$ mes', 'F creac', 'F prim Act', 'F Ult DX', 'F Ult P', '$ Ult P', 'Saldo', 'Mora', 'Fecha cumple']
    //     }
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let fechaCreacionSistema = "", fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", fechaCumple = "", valorUltPago = 0
    //       if(listRtes[i].fechaCreacionSistema){
    //         fechaCreacionSistema = new Date(listRtes[i].fechaCreacionSistema)
    //         fechaCreacionSistema = (fechaCreacionSistema.getUTCFullYear()) + '-' + ((fechaCreacionSistema.getUTCMonth()+1)<10?'0'+(fechaCreacionSistema.getUTCMonth()+1):(fechaCreacionSistema.getUTCMonth()+1)) + '-' + (fechaCreacionSistema.getUTCDate()<10?'0'+fechaCreacionSistema.getUTCDate():fechaCreacionSistema.getUTCDate())
    //         fechaCreacionSistema = new Date(fechaCreacionSistema+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaPrimeraActivacion){
    //         fechaPrimeraActivacion = new Date(listRtes[i].fechaPrimeraActivacion)
    //         fechaPrimeraActivacion = (fechaPrimeraActivacion.getUTCFullYear()) + '-' + ((fechaPrimeraActivacion.getUTCMonth()+1)<10?'0'+(fechaPrimeraActivacion.getUTCMonth()+1):(fechaPrimeraActivacion.getUTCMonth()+1)) + '-' + (fechaPrimeraActivacion.getUTCDate()<10?'0'+fechaPrimeraActivacion.getUTCDate():fechaPrimeraActivacion.getUTCDate())
    //         fechaPrimeraActivacion = new Date(fechaPrimeraActivacion+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaUltDX){
    //         fechaUltDX = new Date(listRtes[i].fechaUltDX)
    //         fechaUltDX = (fechaUltDX.getUTCFullYear()) + '-' + ((fechaUltDX.getUTCMonth()+1)<10?'0'+(fechaUltDX.getUTCMonth()+1):(fechaUltDX.getUTCMonth()+1)) + '-' + (fechaUltDX.getUTCDate()<10?'0'+fechaUltDX.getUTCDate():fechaUltDX.getUTCDate())
    //         fechaUltDX = new Date(fechaUltDX+'T23:00:00.000Z')

    //       }
    //       if(listRtes[i].fechaUltPago){
    //         fechaUltPago = new Date(listRtes[i].fechaUltPago)
    //         fechaUltPago = (fechaUltPago.getUTCFullYear()) + '-' + ((fechaUltPago.getUTCMonth()+1)<10?'0'+(fechaUltPago.getUTCMonth()+1):(fechaUltPago.getUTCMonth()+1)) + '-' + (fechaUltPago.getUTCDate()<10?'0'+fechaUltPago.getUTCDate():fechaUltPago.getUTCDate())
    //         fechaUltPago = new Date(fechaUltPago+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaCumple){
    //         fechaCumple = new Date(listRtes[i].fechaCumple)
    //         fechaCumple = (fechaCumple.getUTCFullYear()) + '-' + ((fechaCumple.getUTCMonth()+1)<10?'0'+(fechaCumple.getUTCMonth()+1):(fechaCumple.getUTCMonth()+1)) + '-' + (fechaCumple.getUTCDate()<10?'0'+fechaCumple.getUTCDate():fechaCumple.getUTCDate())
    //         fechaCumple = new Date(fechaCumple+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].valorUltPago){
    //         valorUltPago = listRtes[i].valorUltPago
    //       }

    //       if(this.props.empresa.empresaArchFE==="conectic"){
    //         xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad, listRtes[i].nombreBarrio, listRtes[i].direccionCli,
    //         listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
    //         listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc, listRtes[i].eMail,
    //         listRtes[i].observaciones, listRtes[i].estadoCliente, listRtes[i].codigoMarquilla, listRtes[i].descrGrupoAfin,
    //         listRtes[i].cargoMensual, fechaCreacionSistema, fechaPrimeraActivacion, fechaUltDX,
    //         fechaUltPago, valorUltPago, listRtes[i].saldoPendiente, listRtes[i].diasMora, fechaCumple]
    //       }else{
    //         xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad, listRtes[i].nombreBarrio, listRtes[i].direccionCli,
    //         listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
    //         listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc, listRtes[i].eMail,
    //         listRtes[i].observaciones, listRtes[i].estadoCliente, listRtes[i].codigoMarquilla, listRtes[i].descrGrupoAfin,
    //         listRtes[i].cargoMensual, fechaCreacionSistema, fechaPrimeraActivacion, fechaUltDX,
    //         fechaUltPago, valorUltPago, listRtes[i].saldoPendiente, listRtes[i].diasMora]
    //       }
    //       xlsString.push(xlsString1)
    //     }
    //   }
    //   if(opciones1==="opcion6"){
    //     let xlsString1 = ['Tercero', 'Ciudad', 'Barrio', 'Dirección', 'Nodo', 'Nombre(s)', 'Apellido(s)', 'Teléfonos', 'Contr', 'Estr', 'Doc', '# Doc', 'Observaciones', 'Est', '$ mes', 'F creac', 'F prim Act', 'F Ult DX', 'F Ult P', '$ Ult P', 'Saldo', 'Mora', 'Clase', 'Cod Tar', 'Tarifa', 'Cod Serv', 'Servicio', 'Cod paq', 'Paquete', 'Cod seg', 'Segmento', 'Cod tipo tec', 'Tipo tecnología', 'Downstream', 'Upstream', 'Mac', 'Clase']
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let fechaCreacionSistema = "", fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", valorUltPago = 0
    //       let mac = ""
    //       if(listRtes[i].mac){
    //         mac = listRtes[i].mac
    //       }
    //       let descrClaseEqu = ""
    //       if(listRtes[i].descrClaseEqu){
    //         descrClaseEqu = listRtes[i].descrClaseEqu
    //       }

    //       if(listRtes[i].fechaCreacionSistema){
    //         fechaCreacionSistema = new Date(listRtes[i].fechaCreacionSistema)
    //         fechaCreacionSistema = (fechaCreacionSistema.getUTCFullYear()) + '-' + ((fechaCreacionSistema.getUTCMonth()+1)<10?'0'+(fechaCreacionSistema.getUTCMonth()+1):(fechaCreacionSistema.getUTCMonth()+1)) + '-' + (fechaCreacionSistema.getUTCDate()<10?'0'+fechaCreacionSistema.getUTCDate():fechaCreacionSistema.getUTCDate())
    //         fechaCreacionSistema = new Date(fechaCreacionSistema+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaPrimeraActivacion){
    //         fechaPrimeraActivacion = new Date(listRtes[i].fechaPrimeraActivacion)
    //         fechaPrimeraActivacion = (fechaPrimeraActivacion.getUTCFullYear()) + '-' + ((fechaPrimeraActivacion.getUTCMonth()+1)<10?'0'+(fechaPrimeraActivacion.getUTCMonth()+1):(fechaPrimeraActivacion.getUTCMonth()+1)) + '-' + (fechaPrimeraActivacion.getUTCDate()<10?'0'+fechaPrimeraActivacion.getUTCDate():fechaPrimeraActivacion.getUTCDate())
    //         fechaPrimeraActivacion = new Date(fechaPrimeraActivacion+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].fechaUltDX){
    //         fechaUltDX = new Date(listRtes[i].fechaUltDX)
    //         fechaUltDX = (fechaUltDX.getUTCFullYear()) + '-' + ((fechaUltDX.getUTCMonth()+1)<10?'0'+(fechaUltDX.getUTCMonth()+1):(fechaUltDX.getUTCMonth()+1)) + '-' + (fechaUltDX.getUTCDate()<10?'0'+fechaUltDX.getUTCDate():fechaUltDX.getUTCDate())
    //         fechaUltDX = new Date(fechaUltDX+'T23:00:00.000Z')

    //       }
    //       if(listRtes[i].fechaUltPago){
    //         fechaUltPago = new Date(listRtes[i].fechaUltPago)
    //         fechaUltPago = (fechaUltPago.getUTCFullYear()) + '-' + ((fechaUltPago.getUTCMonth()+1)<10?'0'+(fechaUltPago.getUTCMonth()+1):(fechaUltPago.getUTCMonth()+1)) + '-' + (fechaUltPago.getUTCDate()<10?'0'+fechaUltPago.getUTCDate():fechaUltPago.getUTCDate())
    //         fechaUltPago = new Date(fechaUltPago+'T23:00:00.000Z')
    //       }
    //       if(listRtes[i].valorUltPago){
    //         valorUltPago = listRtes[i].valorUltPago
    //       }

    //       xlsString1 = [listRtes[i].descrRecursoR, listRtes[i].codigoCiudad, listRtes[i].nombreBarrio,
    //                     listRtes[i].direccionCli, listRtes[i].descrNodo,
    //                     listRtes[i].nombreCliente, listRtes[i].apellidoCliente, listRtes[i].telefonos,
    //                     listRtes[i].contrato, listRtes[i].descrEstrato, listRtes[i].codigoTipoDoc,
    //                     listRtes[i].numeroDoc, listRtes[i].observaciones, listRtes[i].estadoCliente,
    //                     listRtes[i].cargoMensual, fechaCreacionSistema, fechaPrimeraActivacion, fechaUltDX,
    //                     fechaUltPago, valorUltPago, listRtes[i].saldoPendiente, listRtes[i].diasMora,
    //                     listRtes[i].descrClaseServ, listRtes[i].codigoTarifa,
    //                     listRtes[i].descrTarifa, listRtes[i].codigoServicio, listRtes[i].nombreResumido, 
    //                     listRtes[i].codigoPaquete, listRtes[i].descrPaquete, listRtes[i].codigoSegmento,
    //                     listRtes[i].descrSegmento, listRtes[i].codigoTipoTec, listRtes[i].descrTipoTec,
    //                     listRtes[i].velEfecDownstream, listRtes[i].velEfecUpstream,
    //                     mac, descrClaseEqu]
    //                     xlsString.push(xlsString1)
    //     }
    //   }
    //   if(opciones1==="opcion7"){
    //     let xlsString1 = ['Departamento', 'Ciudad', 'Estado', 'Ciclo', 'Clase', 'Total Clientes']
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let totalClientes = 0
    //       if(listRtes[i].totalClientes){
    //         totalClientes = listRtes[i].totalClientes
    //       }

    //       xlsString1 = [listRtes[i].descrDpto, listRtes[i].nombreCiudad, listRtes[i].estadoCliente,
    //                     listRtes[i].cicloFact, listRtes[i].descrClaseServ, totalClientes]
    //       xlsString.push(xlsString1)
    //     }
    //   }
    //   if(opciones1==="opcion8"){
    //     let xlsString1 = ['Departamento', 'Ciudad', 'Barrio', 'Estado', 'Ciclo', 'Clase', 'Total Clientes']
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let totalClientes = 0
    //       if(listRtes[i].totalClientes){
    //         totalClientes = listRtes[i].totalClientes
    //       }

    //       xlsString1 = [listRtes[i].descrDpto, listRtes[i].nombreCiudad, listRtes[i].nombreBarrio,
    //                     listRtes[i].estadoCliente,
    //                     listRtes[i].cicloFact, listRtes[i].descrClaseServ, totalClientes]
    //       xlsString.push(xlsString1)
    //     }
    //   }
    //   if(opciones1==="opcion9"){
    //     // let xlsString1 = ['Contrato', 'Nombre(s)', 'Apellido(s)', 'Estado', 'Saldo', 'Ciclo', 'Boleta', 'Estado boleta', 'Año', 'Mes']
    //     let xlsString1 = ['Contrato', 'Nombre(s)', 'Apellido(s)', 'Documento', 'Teléfono 1', 'Teléfono 2', 'Teléfono 3', 'Estado', 'Saldo', 'Barrio', 'Ciclo', '# para Sorteo']
    //     xlsString.push(xlsString1)

    //     for(let i=0; i<listRtes.length; i++){
    //       let saldoPendiente = 0
    //       if(listRtes[i].saldoPendiente){
    //         saldoPendiente = listRtes[i].saldoPendiente
    //       }

    //       xlsString1 = [listRtes[i].contrato, listRtes[i].nombreCliente, listRtes[i].apellidoCliente,
    //                     listRtes[i].numeroDoc, listRtes[i].telefono1, listRtes[i].telefono2, listRtes[i].telefono3,
    //                     listRtes[i].estadoCliente, saldoPendiente, listRtes[i].nombreBarrio,
    //                     listRtes[i].cicloFact, listRtes[i].numSorteos]
    //                     // listRtes[i].numBoleta, listRtes[i].estado, listRtes[i].agno, listRtes[i].mes]
    //       xlsString.push(xlsString1)
    //     }
    //   }
    //   var wb = XLSX.utils.book_new();

    //   wb.Props = {
    //     Title: "SheetJS Tutorial",
    //     Subject: "Test",
    //     Author: "Red Stapler",
    //     CreatedDate: new Date(2017,12,19)
    //   };
      
    //   wb.SheetNames.push("Clientes");
      
    //   let ws_data = xlsString;
      
    //   let ws = XLSX.utils.aoa_to_sheet(ws_data);
    //   wb.Sheets["Clientes"] = ws;
    //   let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    //   function s2ab(s) { 
    //     let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    //     let view = new Uint8Array(buf);  //create uint8array as viewer
    //     for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    //     return buf;    
    //   }
    //   saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'clientes.xlsx');
    //   //FIN Exportar a XLS
    // }
    // if(targetName==="texto"||(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert")){
    if(targetName==="texto"||targetName==="excel"){
      let sepCampos = "|"
      // if(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert"){
      if(targetName==="excel"){
        sepCampos = ";"
      }
      let txtString = ""
      let listRtes = this.state.listRtes
      if(this.state.opciones1==="opcion4"){
        if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="codisert"){
          let ultCol = "InfAdic"
          let genero = "Género" + sepCampos
          let zona = "Zona" + sepCampos
          if(this.props.empresa.empresaArchFE==="codisert"){
            ultCol = "Grupo Afinidad" + sepCampos + "Ciclo Fact" + sepCampos + "Tipo Cliente"
            genero = ""
            zona = ""
          }
          
          if(targetName==="excel"){
            txtString += 'Tercero;Ciudad;' + zona + 'Barrio;Dirección;Nodo;Nombre(s);Apellido(s);Teléfonos;Contr;' + genero + 'Est;$ mes;'
            txtString += 'F prim Act;F Ult DX;F Ult P;$ Ult P;Saldo;Mora;'
          }else{
            txtString += 'Tercero|Ciudad|' + zona + 'Barrio|Dirección|Nodo|Nombre(s)|Apellido(s)|Teléfonos|Contr|' + genero + 'Est|$ mes|'
            txtString += 'F prim Act|F Ult DX|F Ult P|$ Ult P|Saldo|Mora|'
          }
          txtString += ultCol
          txtString += "\r\n";
        }else{
          // if(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert"){
          if(targetName==="excel"){
            txtString += 'Tercero;Ciudad;Zona;Barrio;Dirección;Nodo;Nombre(s);Apellido(s);Teléfonos;Contr;Est;$ mes;'
            txtString += 'F prim Act;F Ult DX;F Ult P;$ Ult P;Saldo;Mora'
          }else{
            txtString += 'Tercero|Ciudad|Zona|Barrio|Dirección|Nodo|Nombre(s)|Apellido(s)|Teléfonos|Contr|Est|$ mes|'
            txtString += 'F prim Act|F Ult DX|F Ult P|$ Ult P|Saldo|Mora'
          }
          txtString += "\r\n";
        }

        for(let i=0; i<listRtes.length; i++){
          let fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", valorUltPago = 0
          if(listRtes[i].fechaPrimeraActivacion){
            fechaPrimeraActivacion = listRtes[i].fechaPrimeraActivacion.substr(0, 10)
          }
          if(listRtes[i].fechaUltDX){
            fechaUltDX = listRtes[i].fechaUltDX.substr(0, 10)
          }
          if(listRtes[i].fechaUltPago){
            fechaUltPago = listRtes[i].fechaUltPago.substr(0, 10)
          }
          if(listRtes[i].valorUltPago){
            valorUltPago = listRtes[i].valorUltPago
          }

          txtString += listRtes[i].descrRecursoR + sepCampos + listRtes[i].codigoCiudad + sepCampos
          if(this.props.empresa.empresaArchFE!=="codisert"){
            txtString += listRtes[i].nombreZona + sepCampos
          }
          txtString += listRtes[i].nombreBarrio + sepCampos
          txtString += listRtes[i].direccionCli + sepCampos + listRtes[i].descrNodo + sepCampos + listRtes[i].nombreCliente + sepCampos
          txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].telefonos + sepCampos
          txtString += listRtes[i].contrato + sepCampos
          if(this.props.empresa.empresaArchFE==="conectic"){
            txtString += listRtes[i].sexoCliente + sepCampos
          }
          txtString += listRtes[i].estadoCliente + sepCampos
          txtString += listRtes[i].cargoMensual + sepCampos + fechaPrimeraActivacion + sepCampos
          txtString += fechaUltDX + sepCampos + fechaUltPago + sepCampos + valorUltPago + sepCampos
          txtString += listRtes[i].saldoPendiente + sepCampos + listRtes[i].diasMora
          if(this.props.empresa.empresaArchFE==="conectic"){
            txtString += sepCampos + listRtes[i].infAdic1
          }
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += sepCampos + listRtes[i].descrGrupoAfin + sepCampos + listRtes[i].cicloFact + sepCampos + listRtes[i].descrTipoCliente
          }
          txtString += "\r\n";
        }
      }
      if(opciones1==="opcion5"){
        if(targetName==="excel"){
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += 'Tercero;Ciudad;Barrio;Dirección;Nombre(s);Apellido(s);Razón Social;Teléfonos;Contr;Doc;# Doc;DV;Correo;'
          }else{
            txtString += 'Tercero;Ciudad;Zona;Barrio;Dirección;Nombre(s);Apellido(s);Teléfonos;Contr;Doc;# Doc;Correo;'
          }
          if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"){
            txtString += 'Observaciones;Est;Marquilla;Grupo Afinidad;$ mes;F creac;F prim Act;F Ult DX;F Ult P;$ Ult P;Saldo;Mora;Fecha cumple'
          }else{
            txtString += 'Observaciones;Est;Marquilla;Grupo Afinidad;$ mes;F creac;F prim Act;F Ult DX;F Ult P;$ Ult P;Saldo;Mora'
          }
        }else{
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += 'Tercero|Ciudad|Barrio|Dirección|Nombre(s)|Apellido(s)|Teléfonos|Contr|Doc|# Doc|Correo|'
          }else{
            txtString += 'Tercero|Ciudad|Zona|Barrio|Dirección|Nombre(s)|Apellido(s)|Teléfonos|Contr|Doc|# Doc|Correo|'
          }
          if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"){
            txtString += 'Observaciones|Est|Marquilla|Grupo Afinidad|$ mes|F creac|F prim Act|F Ult DX|F Ult P|$ Ult P|Saldo|Mora|Fecha cumple'
          }else{
            txtString += 'Observaciones|Est|Marquilla|Grupo Afinidad|$ mes|F creac|F prim Act|F Ult DX|F Ult P|$ Ult P|Saldo|Mora'
          }
        }
        txtString += "\r\n";

        for(let i=0; i<listRtes.length; i++){
          let fechaCreacionSistema = "", fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", fechaCumple = "", valorUltPago = 0
          if(listRtes[i].fechaCreacionSistema){
            fechaCreacionSistema = listRtes[i].fechaCreacionSistema.substr(0, 10)
          }
          if(listRtes[i].fechaPrimeraActivacion){
            fechaPrimeraActivacion = listRtes[i].fechaPrimeraActivacion.substr(0, 10)
          }
          if(listRtes[i].fechaUltDX){
            fechaUltDX = listRtes[i].fechaUltDX.substr(0, 10)
          }
          if(listRtes[i].fechaUltPago){
            fechaUltPago = listRtes[i].fechaUltPago.substr(0, 10)
          }
          if(listRtes[i].fechaCumple){
            fechaCumple = listRtes[i].fechaCumple.substr(0, 10)
          }
          if(listRtes[i].valorUltPago){
            valorUltPago = listRtes[i].valorUltPago
          }
          let numeroDoc = listRtes[i].numeroDoc
          let digitoVerifEmp = ""
          if(this.props.empresa.empresaArchFE==="codisert"){
            let posic = numeroDoc.indexOf("-")
            if(posic!==-1){
              digitoVerifEmp = numeroDoc.substr(posic + 1)
              numeroDoc = numeroDoc.substr(0, posic)
            }
          }
          let razonSocial = ""
          if(listRtes[i].codigoTipoDoc==="NIT"){
            razonSocial = listRtes[i].nombreCliente + " " + listRtes[i].apellidoCliente
          }

          txtString += listRtes[i].descrRecursoR + sepCampos + listRtes[i].codigoCiudad + sepCampos
          if(this.props.empresa.empresaArchFE!=="codisert"){
            txtString += listRtes[i].nombreZona + sepCampos
          }
          txtString += listRtes[i].nombreBarrio + sepCampos
          txtString += listRtes[i].direccionCli + sepCampos + listRtes[i].nombreCliente + sepCampos
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += listRtes[i].apellidoCliente + sepCampos + razonSocial + sepCampos + listRtes[i].telefonos + sepCampos
          }else{
            txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].telefonos + sepCampos
          }
          txtString += listRtes[i].contrato + sepCampos + listRtes[i].codigoTipoDoc + sepCampos
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += numeroDoc + sepCampos + digitoVerifEmp + sepCampos + listRtes[i].eMail + sepCampos + listRtes[i].observaciones + sepCampos
          }else{
            txtString += numeroDoc + sepCampos + listRtes[i].eMail + sepCampos + listRtes[i].observaciones + sepCampos
          }
          txtString += listRtes[i].estadoCliente + sepCampos + listRtes[i].codigoMarquilla + sepCampos + listRtes[i].descrGrupoAfin + sepCampos + listRtes[i].cargoMensual + sepCampos
          txtString += fechaCreacionSistema + sepCampos + fechaPrimeraActivacion + sepCampos
          txtString += fechaUltDX + sepCampos + fechaUltPago + sepCampos + valorUltPago + sepCampos
          if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"){
            txtString += listRtes[i].saldoPendiente + sepCampos + listRtes[i].diasMora + sepCampos + fechaCumple
          }else{
            txtString += listRtes[i].saldoPendiente + sepCampos + listRtes[i].diasMora
          }

          txtString += "\r\n";
        }
      }
      if(opciones1==="opcion6"){
        if(targetName==="excel"){
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += 'Tercero;Ciudad;Barrio;Dirección;Nodo;Nombre(s);Apellido(s);Teléfonos;Contr;Estr;Doc;# Doc;'
          }else{
            txtString += 'Tercero;Ciudad;Zona;Barrio;Dirección;Nodo;Nombre(s);Apellido(s);Teléfonos;Contr;Estr;Doc;# Doc;'
          }
          if(this.props.empresa.empresaArchFE==="conectic"){
            txtString += 'Correo;'
          }          
          txtString += 'Observaciones;Est;$ mes;F creac;F prim Act;F Ult DX;F Ult P;$ Ult P;Saldo;Mora;Clase;'
          txtString += 'Cod Tar;Tarifa;Cod Serv;Servicio;Cod paq;Paquete;Cod seg;Segmento;Cod tipo tec;Tipo tecnología;Downstream;Upstream;Mac;descrClaseEqu'
        }else{
          if(this.props.empresa.empresaArchFE==="codisert"){
            txtString += 'Tercero|Ciudad|Barrio|Dirección|Nodo|Nombre(s)|Apellido(s)|Teléfonos|Contr|Estr|Doc|# Doc|'
          }else{
            txtString += 'Tercero|Ciudad|Zona|Barrio|Dirección|Nodo|Nombre(s)|Apellido(s)|Teléfonos|Contr|Estr|Doc|# Doc|'
          }
          if(this.props.empresa.empresaArchFE==="conectic"){
            txtString += 'Correo|'
          }          
          txtString += 'Observaciones|Est|$ mes|F creac|F prim Act|F Ult DX|F Ult P|$ Ult P|Saldo|Mora|Clase|'
          txtString += 'Cod Tar|Tarifa|Cod Serv|Servicio|Cod paq|Paquete|Cod seg|Segmento|Cod tipo tec|Tipo tecnología|Downstream|Upstream|Mac|descrClaseEqu'
        }
        txtString += "\r\n";

        for(let i=0; i<listRtes.length; i++){
          let fechaCreacionSistema = "", fechaPrimeraActivacion = "", fechaUltDX = "", fechaUltPago = "", valorUltPago = 0
          let mac = ""
          if(listRtes[i].mac){
            mac = listRtes[i].mac
          }
          let descrClaseEqu = ""
          if(listRtes[i].descrClaseEqu){
            descrClaseEqu = listRtes[i].descrClaseEqu
          }
          
          if(listRtes[i].fechaCreacionSistema){
            fechaCreacionSistema = listRtes[i].fechaCreacionSistema.substr(0, 10)
          }
          if(listRtes[i].fechaPrimeraActivacion){
            fechaPrimeraActivacion = listRtes[i].fechaPrimeraActivacion.substr(0, 10)
          }
          if(listRtes[i].fechaUltDX){
            fechaUltDX = listRtes[i].fechaUltDX.substr(0, 10)
          }
          if(listRtes[i].fechaUltPago){
            fechaUltPago = listRtes[i].fechaUltPago.substr(0, 10)
          }
          if(listRtes[i].valorUltPago){
            valorUltPago = listRtes[i].valorUltPago
          }

          txtString += listRtes[i].descrRecursoR + sepCampos + listRtes[i].codigoCiudad + sepCampos
          if(this.props.empresa.empresaArchFE!=="codisert"){
            txtString += listRtes[i].nombreZona + sepCampos
          }
          txtString += listRtes[i].nombreBarrio + sepCampos
          txtString += listRtes[i].direccionCli + sepCampos + listRtes[i].descrNodo + sepCampos + listRtes[i].nombreCliente + sepCampos
          txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].telefonos + sepCampos
          txtString += listRtes[i].contrato + sepCampos + listRtes[i].descrEstrato + sepCampos
          txtString += listRtes[i].codigoTipoDoc + sepCampos + listRtes[i].numeroDoc + sepCampos
          if(this.props.empresa.empresaArchFE==="conectic"){
            txtString += listRtes[i].eMail + sepCampos
          }          
          txtString += listRtes[i].observaciones + sepCampos + listRtes[i].estadoCliente + sepCampos
          txtString += listRtes[i].cargoMensual + sepCampos + fechaCreacionSistema + sepCampos
          txtString += fechaPrimeraActivacion + sepCampos
          txtString += fechaUltDX + sepCampos + fechaUltPago + sepCampos + valorUltPago + sepCampos
          txtString += listRtes[i].saldoPendiente + sepCampos + listRtes[i].diasMora + sepCampos
          txtString += listRtes[i].descrClaseServ + sepCampos
          txtString += listRtes[i].codigoTarifa + sepCampos + listRtes[i].descrTarifa + sepCampos
          txtString += listRtes[i].codigoServicio + sepCampos + listRtes[i].nombreResumido + sepCampos
          txtString += listRtes[i].codigoPaquete + sepCampos + listRtes[i].descrPaquete + sepCampos + listRtes[i].codigoSegmento + sepCampos
          txtString += listRtes[i].descrSegmento + sepCampos + listRtes[i].codigoTipoTec + sepCampos + listRtes[i].descrTipoTec + sepCampos
          txtString += listRtes[i].velEfecDownstream + sepCampos + listRtes[i].velEfecUpstream + sepCampos + mac + sepCampos + descrClaseEqu
          txtString += "\r\n";
          // console.log(txtString)
        }
      }
      if(opciones1==="opcion7"){
        if(targetName==="excel"){
          txtString += 'Departamento;Ciudad;Estado;Ciclo;Clase;Total Clientes'
        }else{
          txtString += 'Departamento|Ciudad|Estado|Ciclo|Clase|Total Clientes'
        }
        txtString += "\r\n";

        for(let i=0; i<listRtes.length; i++){
          let totalClientes = 0
          if(listRtes[i].totalClientes){
            totalClientes = listRtes[i].totalClientes
          }

          txtString += listRtes[i].descrDpto + sepCampos + listRtes[i].nombreCiudad + sepCampos + listRtes[i].estadoCliente + sepCampos
          txtString += listRtes[i].cicloFact + sepCampos + listRtes[i].descrClaseServ + sepCampos
          txtString += totalClientes

          txtString += "\r\n";
          // console.log(txtString)
        }
      }
      if(opciones1==="opcion8"){
        if(targetName==="excel"){
          txtString += 'Departamento;Ciudad;Barrio;Estado;Ciclo;Clase;Total Clientes'
        }else{
          txtString += 'Departamento|Ciudad|Barrio|Estado|Ciclo|Clase|Total Clientes'
        }
        txtString += "\r\n";

        for(let i=0; i<listRtes.length; i++){
          let totalClientes = 0
          if(listRtes[i].totalClientes){
            totalClientes = listRtes[i].totalClientes
          }

          txtString += listRtes[i].descrDpto + sepCampos + listRtes[i].nombreCiudad + sepCampos + listRtes[i].nombreBarrio + sepCampos + listRtes[i].estadoCliente + sepCampos
          txtString += listRtes[i].cicloFact + sepCampos + listRtes[i].descrClaseServ + sepCampos
          txtString += totalClientes

          txtString += "\r\n";
          // console.log(txtString)
        }
      }
      if(opciones1==="opcion9"){
        if(targetName==="excel"){
          txtString += 'Contrato;Nombre(s);Apellido(s);Documento;Teléfono 1;Teléfono 2;Teléfono 3;Estado;Saldo;Barrio;Ciclo;# para Sorteo'
        }else{
          txtString += 'Contrato|Nombre(s)|Apellido(s)|Documento|Teléfono 1|Teléfono 2|Teléfono 3|Estado|Saldo|Barrio|Ciclo|# para Sorteo'
        }
        txtString += "\r\n";

        for(let i=0; i<listRtes.length; i++){
          let saldoPendiente = 0
          if(listRtes[i].saldoPendiente){
            saldoPendiente = listRtes[i].saldoPendiente
          }

          txtString += listRtes[i].contrato + sepCampos + listRtes[i].nombreCliente + sepCampos + listRtes[i].apellidoCliente + sepCampos + listRtes[i].numeroDoc + sepCampos + listRtes[i].telefono1 + sepCampos + listRtes[i].telefono2 + sepCampos + listRtes[i].telefono3 + sepCampos + listRtes[i].estadoCliente + sepCampos
          // txtString += saldoPendiente +sepCampos + listRtes[i].cicloFact + sepCampos + listRtes[i].numBoleta + sepCampos + listRtes[i].estado + sepCampos + listRtes[i].agno + sepCampos + listRtes[i].mes
          txtString += saldoPendiente + sepCampos + listRtes[i].nombreBarrio +sepCampos + listRtes[i].cicloFact + sepCampos + listRtes[i].numSorteos

          txtString += "\r\n";
          // console.log(txtString)
        }
      }
      var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
      // if(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert"){
      if(targetName==="excel"){
        saveAs(blob, "clientes.csv");
      }else{
        saveAs(blob, "clientes.txt");
      }
    }

    document.body.style.cursor = 'default'

    // console.log("listooooo")
  }

  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.state.opciones1!=="opcion7"&&this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.state.opciones1!=="opcion7"&&this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        (this.state.opciones1!=="opcion7"&&this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona)||
        (this.state.opciones1!=="opcion7"&&this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio)){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      if(this.state.opciones1!=="opcion7"){
        argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
        argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      }
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      this.setState({listRtes: [], totCli: 0})
      this.setState({verEnPantalla: false})
    }
  }

  shouldComponentUpdate(){
    if(this.state.renderizar){
      return true
    }else{
      return false
    }
  }

  componentWillUnmount(){
    let listRtes = []
    this.setState({listRtes})
    this.setState({verEnPantalla: false})
  }

  render(){
    const {argsDocum, opciones, opciones1, listRtes, totCli,
            confirmaAct, errors, verEnPantalla} = this.state;
    const a150101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150101" );
    const a150103 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150103" );
    const a150105 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150105" );
    const a150110 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150110" );

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let listaGA = []
    if(this.props.allGruposAfin.allGruposAfin){
      listaGA = this.props.allGruposAfin.allGruposAfin
    }
    
    let listaNodo = []
    if(this.props.allNodo.allNodo){
      listaNodo = this.props.allNodo.allNodo
    }

    let tipoArch = "ARCHIVO EXCEL"
    // if(this.props.empresa.empresaArchFE==="codisert"){
      tipoArch = "ARCHIVO CSV"
    // }
    // console.log(this.props.empresa.empresaArchFE)
            // console.log(listOSCl)

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// console.log(this.props.allClientes.allClientes)
// console.log(this.props.list2)
// console.log(this.state.argsSelDpto)
// console.log(argsDocum)
// console.log("1875 renderizar", renderizar)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Clientes
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1):()=>{}}>
              <div>
              <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '15%'}}>
                      <h1 style={{color: '#2C7744'}}>Clientes</h1>
                    </div>
                    {/* <div className="column" style={{width: '30%'}}>
                      <Button id="diasmora" name="diasmora" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
                          color: '#89253e'}} onClick={this.handlediasMora}>
                        Verificar inconsistencias
                      </Button>
                    </div> */}
                    {(this.props.empresa.empresaArchFE==="codisert"&&a150110!==-1) &&
                      <div className="column" style={{width: '40%'}}>
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Servicios&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion7" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion8" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales por barrio&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>                      
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion9" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Sorteos</label>                        
                        </fieldset>
                      </div>
                    }
                    {(this.props.empresa.empresaArchFE!=="codisert"||a150110===-1) &&
                      <div className="column" style={{width: '40%'}}>
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Servicios&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion7" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion8" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales por barrio</label>                        
                        </fieldset>
                      </div>
                    }
                    {(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9") &&
                      <div className="column" style={{width: '40%'}}>
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Ordenar por&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Tercero + Barrio + Dir&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Nombre&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Contrato</label>
                        </fieldset>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                {(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9") &&
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Estado
                        </p>
                        <Form.Field>
                          <Lista styles={this.props.styles} list={this.props.list2} argsDocum={argsDocum} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkDiasMoraIni" checked={argsDocum.checkDiasMoraIni} onChange={this.handleChange}/>
                            &nbsp;&nbsp;Mora mayor o igual a XX días
                          </p>
                          <input value={argsDocum.diasMoraIni} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="diasMoraIni" id="diasMoraIni" placeholder='Días en mora' onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkDiasMoraFin" checked={argsDocum.checkDiasMoraFin} onChange={this.handleChange}/>
                            &nbsp;&nbsp;Mora menor o igual a YY días
                          </p>
                          <input value={argsDocum.diasMoraFin} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="diasMoraFin" id="diasMoraFin" placeholder='Días en mora' onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                {(opciones1==="opcion7"||opciones1==="opcion8") &&
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Estado
                        </p>
                        <Form.Field>
                          <Lista styles={this.props.styles} list={this.props.list2} argsDocum={argsDocum} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                {opciones1!=="opcion9" &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciclo de facturación
                        </p>
                        <Form.Field>
                          <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Clase
                        </p>
                        <Form.Field>
                          <ListaClase styles={this.props.styles} list={this.props.list3} handleLista4={this.props.handleLista4}  argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                {(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9") &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Tercero
                        </p>
                        <Form.Field>
                          <ListaRecaudo list={this.props.list} styles={this.props.styles} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Grupo de afinidad
                        </p>
                        <Form.Field>
                          <ListaGA styles={this.props.styles} list={listaGA} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                {opciones1!=="opcion9" &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Departamento
                          </label>
                          <ListaDe list={this.props.list1} styles={this.props.styles}
                            handleLista={this.props.handleLista}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Ciudad
                          </label>
                          <ListaCi list={listCiu} styles={this.props.styles}
                            handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                            codigoCiudadUA={this.props.codigoCiudadUA}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                {(opciones1!=="opcion7"&&opciones1!=="opcion9") &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Zona
                          </label>
                          <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2}
                            argsSelDpto={this.props.argsSelDpto}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Barrio
                          </label>
                          <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3}
                            argsSelDpto={this.props.argsSelDpto}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                {(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9") &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Nodo
                        </p>
                        <Form.Field>
                          <ListaNodo styles={this.props.styles} list={listaNodo} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                {(opciones1!=="opcion7"&&opciones1!=="opcion8"&&opciones1!=="opcion9") &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Total Clientes: {totCli}
                  </p>
                }
                <div className="ui four column stackable grid">
                  <div className="row container">
                    {/* {opciones1!=="opcion9" && */}
                      <div className="column" style={{width: '25%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                          VER EN PANTALLA
                        </Button>
                      </div>
                    {/* } */}
                    {a150101!==-1 &&
                      <div className="column" style={{width: '25%'}}>
                        <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                          {tipoArch}
                        </Button>
                      </div>
                    }
                    {(a150103!==-1&&opciones1!=="opcion9") &&
                      <div className="column" style={{width: '25%'}}>
                        <Button id="texto" name="texto" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                          ARCHIVO TEXTO
                        </Button>
                      </div>
                    }
                    {(a150105!==-1&&opciones1!=="opcion9") &&
                      <div className="column" style={{width: '25%'}}>
                        <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                          ARCHIVO PDF
                        </Button>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>
              {(opciones1==="opcion4"&&this.props.empresa.empresaArchFE!=="conectic") &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Tercero</th>
                      <th className=''>Ciudad</th>
                      {this.props.empresa.empresaArchFE!=="codisert" &&
                        <th className=''>Zona</th>
                      }
                      <th className=''>Barrio</th>
                      <th className=''>Dirección</th>
                      <th className=''>Nodo</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      <th className=''>Teléfonos</th>
                      <th className=''>Contr</th>
                      <th className=''>Est</th>
                      <th className=''>$ mes</th>
                      <th className=''>F prim Act</th>
                      <th className=''>F Ult DX</th>
                      <th className=''>F Ult P</th>
                      <th className=''>$ Ult P</th>
                      <th className=''>Saldo</th>
                      <th className=''>Mora</th>
                      {this.props.empresa.empresaArchFE==="codisert" &&
                        <th className=''>Grupo Afinidad</th>
                      }
                      {this.props.empresa.empresaArchFE==="codisert" &&
                        <th className=''>Ciclo Fact</th>
                      }
                      {this.props.empresa.empresaArchFE==="codisert" &&
                        <th className=''>Tipo Cliente</th>
                      }
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1} empresaArchFE={this.props.empresa.empresaArchFE}/>
                  }
                </table>
              }
              {(opciones1==="opcion4"&&this.props.empresa.empresaArchFE==="conectic") &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Tercero</th>
                      <th className=''>Ciudad</th>
                      {this.props.empresa.empresaArchFE!=="codisert" &&
                        <th className=''>Zona</th>
                      }
                      <th className=''>Barrio</th>
                      <th className=''>Dirección</th>
                      <th className=''>Nodo</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      <th className=''>Teléfonos</th>
                      <th className=''>Contr</th>
                      <th className=''>Género</th>
                      <th className=''>Est</th>
                      <th className=''>$ mes</th>
                      <th className=''>F prim Act</th>
                      <th className=''>F Ult DX</th>
                      <th className=''>F Ult P</th>
                      <th className=''>$ Ult P</th>
                      <th className=''>Saldo</th>
                      <th className=''>Mora</th>
                      <th className=''>Inf Adic</th>
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1} empresaArchFE={this.props.empresa.empresaArchFE}/>
                  }
                </table>
              }

              {opciones1==="opcion5" &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Tercero</th>
                      <th className=''>Ciudad</th>
                      {this.props.empresa.empresaArchFE!=="codisert" &&
                        <th className=''>Zona</th>
                      }
                      <th className=''>Barrio</th>
                      <th className=''>Dirección</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      {this.props.empresa.empresaArchFE==="codisert" &&
                        <th className=''>Razón Social</th>
                      }
                      <th className=''>Teléfonos</th>
                      <th className=''>Contr</th>
                      <th className=''>Doc</th>
                      <th className=''># Doc</th>
                      {this.props.empresa.empresaArchFE==="codisert" &&
                        <th className=''>DV</th>
                      }
                      <th className=''>Correo</th>
                      <th className=''>Observaciones</th>
                      <th className=''>Est</th>
                      <th className=''>Marquilla</th>
                      <th className=''>Grupo Afinidad</th>
                      <th className=''>$ mes</th>
                      <th className=''>F creac</th>
                      <th className=''>F prim Act</th>
                      <th className=''>F Ult DX</th>
                      <th className=''>F Ult P</th>
                      <th className=''>$ Ult P</th>
                      <th className=''>Saldo</th>
                      <th className=''>Mora</th>
                      {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                        <th className=''>Fecha cumple</th>
                      }
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1} empresaArchFE={this.props.empresa.empresaArchFE}/>
                  }
                  </table>
              }

              {opciones1==="opcion6" &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Tercero</th>
                      <th className=''>Ciudad</th>
                      {this.props.empresa.empresaArchFE!=="codisert" &&
                        <th className=''>Zona</th>
                      }
                      <th className=''>Barrio</th>
                      <th className=''>Dirección</th>
                      <th className=''>Nodo</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      <th className=''>Teléfonos</th>
                      <th className=''>Contr</th>
                      <th className=''>Estr</th>
                      <th className=''>Doc</th>
                      <th className=''># Doc</th>
                      {this.props.empresa.empresaArchFE==="conectic" &&
                        <th className=''>Correo</th>
                      }
                      <th className=''>Observaciones</th>
                      <th className=''>Est</th>
                      <th className=''>$ mes</th>
                      <th className=''>F creac</th>
                      <th className=''>F prim Act</th>
                      <th className=''>F Ult DX</th>
                      <th className=''>F Ult P</th>
                      <th className=''>$ Ult P</th>
                      <th className=''>Saldo</th>
                      <th className=''>Mora</th>
                      <th className=''>Clase</th>
                      <th className=''>Cod Tar</th>
                      <th className=''>Tarifa</th>
                      <th className=''>Cod Serv</th>
                      <th className=''>Servicio</th>

                      <th className=''>Cod paq</th>
                      <th className=''>Paquete</th>
                      <th className=''>Cod seg</th>
                      <th className=''>Segmento</th>
                      <th className=''>Cod tipo tec</th>
                      <th className=''>Tipo tecnología</th>
                      <th className=''>Downstream</th>
                      <th className=''>Upstream</th>

                      <th className=''>Mac</th>
                      <th className=''>Clase</th>
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1} empresaArchFE={this.props.empresa.empresaArchFE}/>
                  }
                </table>
              }
              {opciones1==="opcion7" &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Departamento</th>
                      <th className=''>Ciudad</th>
                      <th className=''>Estado</th>
                      <th className=''>Ciclo</th>
                      <th className=''>Clase</th>
                      <th className='right aligned'>Total Clientes</th>
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1}/>
                  }
                </table>
              }
              {opciones1==="opcion8" &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Departamento</th>
                      <th className=''>Ciudad</th>
                      <th className=''>Barrio</th>
                      <th className=''>Estado</th>
                      <th className=''>Ciclo</th>
                      <th className=''>Clase</th>
                      <th className='right aligned'>Total Clientes</th>
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1}/>
                  }
                </table>
              }
              {opciones1==="opcion9" &&
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Contrato</th>
                      <th className=''>Nombre(s)</th>
                      <th className=''>Apellido(s)</th>
                      <th className=''>Documento</th>
                      <th className=''>Teléfono 1</th>
                      <th className=''>Teléfono 2</th>
                      <th className=''>Teléfono 3</th>
                      <th className=''>Estado</th>
                      <th className='right aligned'>Saldo</th>
                      <th className=''>Barrio</th>
                      <th className=''>Ciclo</th>
                      {/* <th className=''>Boleta</th>
                      <th className=''>Estado boleta</th>
                      <th className=''>Año</th>
                      <th className=''>Mes</th> */}
                      <th className=''># para Sorteo</th>
                    </tr>
                  </thead>
                  {verEnPantalla &&
                    <ListaCli list={listRtes} opciones1={opciones1}/>
                  }
                </table>
              }

                </div>  
              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {contrato: "ABCXYZ"}}}}),
  // graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: argsBuscarCLR}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),

  graphql(queries.query.allGruposAfin, {name:'allGruposAfin'}),

  // graphql(queries.query.allMovRtes, {name:'allMovRtes', options: (props) => {return {variables: argsBuscarMC}}}),
  graphql(queries.query.allMovRtes, {name:'allMovRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'X'}}]`}}}}),

  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {orden: '-_id'}}}}),

  graphql(queries.query.allNodo, {name:'allNodo'}),

  // graphql(queries.query.allBoletaRtes, {name:'allBoletaRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),

  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editMovClientesPHMany, {name:'editMovClientesPHMany'}),

  graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),

  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allAjusteTodo, {name:'allAjusteTodo', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allCargoEsp, {name:'allCargoEsp', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allDetalleDX, {name:'allDetalleDX', options: (props) => {return {variables: {}}}}),
  
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {}}}}),
  // graphql(queries.mutation.editFacturacionUpdDoc, {name:'editFacturacionUpdDoc'}),
  
  // graphql(queries.query.allMovRtes, {name:'allMovRtes1', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allNotasDebCre, {name:'allNotasDebCre', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allOdeS, {name:'allOdeS', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allPagoClientes, {name:'allPagoClientes', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  // graphql(queries.mutation.editAjuste, {name:'editAjuste'}),
  // graphql(queries.mutation.editCargoEsp, {name:'editCargoEsp'}),
  // graphql(queries.mutation.editDetalleDX, {name:'editDetalleDX'}),
  // graphql(queries.mutation.editFacturacion, {name:'editFacturacion'}),
  // graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),
  // graphql(queries.mutation.editNotasDebCre, {name:'editNotasDebCre'}),
  // graphql(queries.mutation.editOdeSContr, {name:'editOdeSContr'}),
  // graphql(queries.mutation.editPagoClientes, {name:'editPagoClientes'}),

  graphql(queries.mutation.deleteCliente, {name:'deleteCliente'}),

  // graphql(queries.query.allUsuarios, {name:'allUsuarios'}),

)(RtesCli2)
